import { ToastProvider } from '@camplify/onlyvans-web/client'
import { router as inertiaRouter } from '@inertiajs/react'
import type { ReactElement } from 'react'
import { RouterProvider } from 'react-aria-components'

export function OnlyvansRoot({
  children,
  ssr,
}: {
  children: ReactElement
  ssr: boolean
}) {
  void ssr
  return (
    <div data-theme="camplify">
      <RouterProvider navigate={(href) => void inertiaRouter.visit(href)}>
        <ToastProvider>{children}</ToastProvider>
      </RouterProvider>
    </div>
  )
}
